import { render, staticRenderFns } from "./AddContactForm.vue?vue&type=template&id=f107730a&scoped=true&"
import script from "./AddContactForm.vue?vue&type=script&lang=js&"
export * from "./AddContactForm.vue?vue&type=script&lang=js&"
import style0 from "./AddContactForm.vue?vue&type=style&index=0&id=f107730a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f107730a",
  null
  
)

export default component.exports